"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const FeedbackMessage = ({ message }) => {
    return (react_1.default.createElement(material_1.Grid, { container: true, justifyContent: "center", alignItems: "center", style: { height: "100vh" } },
        react_1.default.createElement(material_1.Grid, { item: true },
            react_1.default.createElement(material_1.Typography, { variant: "h2", align: "center" }, message))));
};
function Feedback({ feedback }) {
    return (react_1.default.createElement(material_1.Container, null, feedback === "startup"
        ? react_1.default.createElement(FeedbackMessage, { message: "Loading app..." })
        : feedback === "login"
            ? react_1.default.createElement(FeedbackMessage, { message: "Trying to sign in..." })
            : feedback === "handleRedirect"
                ? react_1.default.createElement(FeedbackMessage, { message: "Redirecting to the app..." })
                : feedback === "logout"
                    ? react_1.default.createElement(FeedbackMessage, { message: "Logging out..." })
                    : feedback === "acquireToken"
                        ? react_1.default.createElement(FeedbackMessage, { message: "Acquiring token..." })
                        : feedback === "ssoSilent"
                            ? react_1.default.createElement(FeedbackMessage, { message: "Silent login..." })
                            : feedback));
}
exports.default = Feedback;
